import { Box, Button, Typography } from '@mui/material';
import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';

export const InsuranceBrokerEmpty = () => {
  const { handleOpen: handleOpenInsuranceBrokerDialog } = useModal(ModalsKeys.InsuranceAddEditBrokerDialog);

  return (
    <Box>
      <Typography mb={1} component="p" variant="body1">
        There is no information yet. You can send Request or add Agent & Policy Details manually
      </Typography>
      <Button size="small" color="primary" onClick={() => handleOpenInsuranceBrokerDialog()} sx={{ marginRight: 1 }}>
        Add manually
      </Button>
      <Button size="small" color="primary" onClick={() => {}} disabled>
        Request Insurance Agent Information
      </Button>
    </Box>
  );
};
